import React from 'react';

const EventCard = ({ title, date, time, location, description, imageUrl }) => (
  <div className="bg-white shadow-lg rounded-lg overflow-hidden flex flex-col h-full">
    <img className="w-full h-48 object-cover" src={imageUrl} alt={title} />
    <div className="p-6 flex flex-col flex-grow">
      <h2 className="text-2xl font-bold text-gray-800 mb-2">{title}</h2>
      <p className="text-purple-600 font-semibold mb-4">{date} at {time}</p>
      <p className="text-gray-600 mb-2"><strong>Location:</strong> {location}</p>
      <p className="text-gray-700 mb-4 flex-grow">{description}</p>
      <div className="mt-auto">
        <a href="/" className="inline-block bg-purple-600 text-white py-2 px-4 rounded hover:bg-purple-700 transition duration-300">RSVP</a>
      </div>
    </div>
  </div>
);

const Events = () => {
  const events = [
    {
      id: 1,
      title: "October Book Club Meeting",
      date: "October 15, 2024",
      time: "19:00",
      location: "Seehaus, Munich",
      description: "Join us for a lively discussion of 'The Midnight Library' by Matt Haig. We'll explore themes of choice, regret, and the infinite possibilities of life.",
      imageUrl: "https://images.unsplash.com/photo-1534644107580-3a4dbd494a95?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80"
    },
    {
      id: 2,
      title: "Author Q&A Session: Jane Doe",
      date: "October 22, 2024",
      time: "18:30",
      location: "Online via Zoom",
      description: "Get ready for an exclusive Q&A session with Jane Doe, author of our November pick. Bring your questions and insights for an engaging virtual meetup!",
      imageUrl: "https://images.unsplash.com/photo-1590650046871-92c887180603?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80"
    },
    {
      id: 3,
      title: "Munich Literature Festival Outing",
      date: "November 5, 2024",
      time: "14:00",
      location: "Gasteig HP8, Munich",
      description: "Let's explore the Munich Literature Festival together! We'll attend readings, panel discussions, and maybe even discover our next book club pick.",
      imageUrl: "https://images.unsplash.com/photo-1540575861501-7cf05a4b125a?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80"
    },
  ];

  return (
    <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">Upcoming Events</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {events.map(event => (
          <EventCard key={event.id} {...event} />
        ))}
      </div>
    </div>
  );
};

export default Events;